import React from 'react';
import { Typography, Box, Grid, Card } from '@mui/material';

import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { Footer } from '../Footer';
import HeroContainer from '../ui/hero-container';
import { useNavigate } from 'react-router-dom';
import Button from '../ui/button/Button';
import ButtonOutline from '../ui/button/ButtonOutline';
import HeaderAlt from '../HeaderAlt';

const rolesData = [
  {
    title: 'Test Automation Developer',
    description: 'Engineering | Full time, Remote',
  },
  {
    title: 'AI Engineer',
    description: 'Engineering | Full time, Remote',
  },
  {
    title: 'Marketing Manager',
    description: 'Marketing | Full time, Remote',
  },
  {
    title: 'Business Developer',
    description: 'Sales | Full time, Remote',
  },
  {
    title: 'Finance Manager',
    description: 'Finance | Full time, Remote',
  },
  {
    title: 'Front End Engineering',
    description: 'Engineering | Full time, Remote',
  },
  {
    title: 'Social media associate',
    description: 'Marketing | Internship (high school and college students only), Remote',
  },
  {
    title: 'DevOps/Infrastructure Engineer',
    description: 'Engineering | Full time',
  },
];

const Careers = () => {
  const navigate = useNavigate();

  return (
    <div className="flex-container">
      <HeaderAlt />
      <HeroContainer className="landing-section !pb-12">
        <p className="tagline fredoka">I AM Always improving 🚀</p>
        <h1 className="headline hero-title !font-semibold">
          We are revolutionizing learning
          <br />
          for the future generation
        </h1>
        <p className="description !max-w-[770px]">
          Let&apos;s grow, learn, connect and make education accessible to all. Everything that make
          you who you are is welcome here.
        </p>
        <div className="mt-6 flex w-full flex-col-reverse justify-center gap-4 md:flex-row">
          <Button className="text-base md:!w-fit" label={'See Open Positions'} />
          <ButtonOutline
            className="md:!w-fit"
            onClick={() => navigate('/waitlist')}
            label={'Contact Us'}
          />
        </div>
      </HeroContainer>
      <Grid
        container
        spacing={3}
        justifyContent="center"
        sx={{ marginTop: '20px', padding: '0px 12px 0px' }}
      >
        {rolesData.map((role, index) => (
          <Grid item xs={12} key={index}>
            <Card
              className="roles-center"
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: { xs: '12px', sm: '18px' }, // Reduced padding for mobile
                borderRadius: '32px',
                maxWidth: '800px',
                backgroundColor: '#E0F7FA',
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '24px',
                    width: { xs: '40px', sm: '50px', md: '65px', lg: '83px' }, // Smaller image size on mobile
                    height: { xs: '40px', sm: '50px', md: '65px', lg: '83px' },
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <img
                    src="/images/icons/grad-img.svg"
                    alt="grad-img"
                    style={{ width: '50%', height: 'auto' }}
                  />
                </Box>
                <Box sx={{ textAlign: 'left' }}>
                  <Typography
                    variant="h6"
                    sx={{
                      color: '#012E33',
                      fontWeight: 'normal',
                      fontSize: { xs: '14px', sm: '16px', md: '18px' }, // Smaller font size on mobile
                    }}
                  >
                    {role.title}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      color: '#678285',
                      fontSize: { xs: '12px', sm: '14px' }, // Smaller font size on mobile
                    }}
                  >
                    {role.description}
                  </Typography>
                </Box>
              </Box>
              <Box
                sx={{
                  borderRadius: '24px',
                  border: '1px solid #044047',
                  width: { xs: '40px', sm: '50px', md: '65px', lg: '83px' }, // Smaller icon size on mobile
                  height: { xs: '40px', sm: '50px', md: '65px', lg: '83px' },
                  display: { xs: 'none', sm: 'flex' },
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
                onClick={() => navigate('/contact')}
              >
                <ArrowForwardIosIcon
                  sx={{ color: '#003B47', fontSize: { xs: '16px', sm: '20px' } }}
                />{' '}
                {/* Adjust icon size for mobile */}
              </Box>
            </Card>
          </Grid>
        ))}
      </Grid>
      <div className="container  !mb-10 !mt-12 flex flex-col  items-center justify-center rounded-[32px] bg-[#85D7D6] !pt-4 md:!mx-auto md:!mb-[64px]  lg:flex-row  lg:rounded-[56px]">
        <div className="mx-4 flex flex-col">
          <h2 className="fredoka  max-w-[502px]   text-center text-[28px] font-bold text-[#012E33] md:px-0 md:text-start md:text-[40px] ">
            We are also looking for passionate tutors to teach our students
          </h2>
          <button
            className={`cta-button primary fredokaOne !mx-auto mt-5 !w-full  !bg-white !py-3 text-base !text-[#012E33] shadow-[0px_1px_2px_0px_rgba(255,255,255,0.40)inset,0px_4px_4px_0px_rgba(255,255,255,0.35)inset] md:!mx-0 md:mt-2 md:!w-fit `}
            onClick={() => navigate('/apply-as-tutor')}
          >
            Apply as a tutor
          </button>
        </div>
        <div className=" lg:-mt-[89px]  ">
          <img
            src="/images/icons/career_group.svg"
            alt="career_group"
            className="h-[242px] w-[318px] lg:h-[440px] lg:w-[556px] "
          />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Careers;
